<!-- <section class="section" *ngIf="!hideHeader || !isMobile">
  <div class="text-center py-4">
    <img
      [src]="businessData?.logo"
      class="avatar avatar-medium mx-auto rounded-circle d-block my-3"
      alt=""
    />
    <a
      target="_blank"
      routerLink="/{{ businessData?.name }}"
      class="text-dark fs-5 name"
      >{{ businessData?.name }}</a
    >
  </div>

  <div class="row my-5 pt-4 pt-sm-0 justify-content-center">
    <div class="col-md-4">
      -- Payment Form --
      <div class="payment-card mb-5" *ngIf="!isMobile || step === 1">
        <div class="payment-card-header">
          {{ "Buyer.FillForm" | translate }}
        </div>
        <div class="payment-card-body">
          <fieldset [disabled]="step === 2 || step === 3">
            <div *ngIf="customPaymentForm">
              <div class="col-12 mb-1">
                <app-number
                  [fieldObject]="customPaymentFields.amount"
                  [fieldErrors]="formValidator.formErrors"
                  [formControlRef]="
                    convertPaymentControl(customPaymentFields.amount.fieldName)
                  "
                  class="amount-field"
                  (change)="onAmountChange($event.target.value)"
                >
                </app-number>
                <p style="margin: 14px 0 10px 10px">
                  {{ "Buyer.amountP" | translate }}
                </p>
              </div>
              <div class="col-12 mb-1">
                <select
                  #currency
                  (change)="onCurrencyChange(currency.value)"
                  class="currencyDropdown"
                >
                  <option disabled value="null" selected>
                    {{ "Buyer.Choose_the_currency" | translate }}
                  </option>
                  <option selected>EGP</option>
                  <option>USD</option>
                  <option>EUR</option>
                  <option>SAR</option>
                  <option>GBP</option>
                </select>
              </div>
            </div>
          </fieldset>
          -- "Next" Button -
          <button
            class="btn btn-primary mt-3"
            (click)="nextStep()"
            *ngIf="isMobile"
          >
            Next
          </button>
        </div>
      </div>
    </div>
    <div class="col-md-8">
      <div class="row">
        <div class="col-md-6">
          -- ----   Payment Options --- --
          <div
            class="payment-card mb-5"
            *ngIf="(!isMobile || step === 2) && businessData"
          >
            <div class="payment-card-header">
              {{ "Buyer.SelectPaymentOptions" | translate }}
            </div>
            <div class="payment-card-body">
              <fieldset>
                <app-buyer-payment-options
                  [expired]="false"
                  [checked]="checked"
                  [isFreePayment]="true"
                  [businessId]="businessId"
                  [totalAmount]="vpihs.total"
                  (clickEvent)="radioChange()"
                  (click)="calculateAmount()"
                >
                </app-buyer-payment-options>
              </fieldset>
            </div>
          </div>
          -- "Previous" and "Next" Buttons --
          <div
            *ngIf="isMobile && step === 2"
            class="d-flex justify-content-between ps-4 pe-4"
          >
            <button
              class="btn btn-outline-primary"
              (click)="previousStep(step)"
            >
              Previous
            </button>
            <button
              *ngIf="step !== 1"
              class="btn btn-primary"
              (click)="submit()"
              [disabled]="isContinueDisabled()"
            >
              {{ "Buyer.Continue" | translate }}
            </button>
          </div>
        </div>
        <div class="col-md-6">
          -- -- Invoice -- --
          <div class="payment-card mb-5" *ngIf="!isMobile">
            <div class="payment-card-header">
              {{ "Buyer.Invoice" | translate }}
            </div>
            <div class="payment-card-body">
              <div class="table-responsive">
                <table class="table table-center table-padding mb-0">
                  <tbody>
                    <tr>
                      <td class="fs-6 border-0 pt-4">
                        {{ "Buyer.Subtotal" | translate }}
                      </td>
                      <td class="text-end fw-bold border-0 pt-4">
                        {{ subTotal.toFixed(2) }} {{ selectedCurrency }}
                      </td>
                    </tr>
                    <tr>
                      <td class="fs-6">{{ "Buyer.Fees" | translate }}</td>
                      <td class="text-end fw-bold">
                        {{ fees.toFixed(2) }} {{ selectedCurrency }}
                      </td>
                    </tr>
                    <tr class="bg-light">
                      <td class="fs-5 fw-bold">
                        {{ "Buyer.Total" | translate }}
                      </td>
                      <td class="text-end text-primary fs-4 fw-bold">
                        {{ total.toFixed(2) }} {{ selectedCurrency }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <ul
                class="nav nav-pills justify-content-between"
                id="pills-tab"
                role="tablist"
              >
                <li class="nav-item" role="presentation" *ngIf="step !== 1">
                  <button
                    class="btn btn-outline-primary"
                    id="pills-home-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-home"
                    type="button"
                    role="tab"
                    aria-controls="pills-home"
                    aria-selected="false"
                    (click)="previousStep(step)"
                  >
                    {{ "Buyer.EditAmount" | translate }}
                  </button>
                </li>
                <li class="nav-item" role="presentation ">
                  <button
                    *ngIf="step !== 1"
                    class="btn btn-primary"
                    (click)="submit()"
                    [disabled]="isContinueDisabled()"
                  >
                    {{ "Buyer.Continue" | translate }}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <router-outlet *ngIf="!isMobile"></router-outlet>
</section> -->

<div *ngIf="!hideHeader">
  <div class="text-center py-4">
    <img
      [src]="businessData?.logo"
      class="avatar avatar-medium mx-auto rounded-circle d-block my-3"
      alt=""
    />
    <a
      target="_blank"
      routerLink="/{{ businessData?.name }}"
      class="text-dark fs-5 name"
      >{{ businessData?.name }}</a
    >
  </div>
  <div class="container">
    <h2 class="mb-2 text-primary fw-bold fs-5">
      {{ "Buyer.FillForm" | translate }}
    </h2>
    <div class="row">
      <div class="col-12 mt-3">
        <fieldset [disabled]="disableSection">
          <div class="row">
            <div class="custom-amount col-md-6 px-2 col-sm-12 col-12">
              <app-number
                [fieldObject]="customPaymentFields.amount"
                [fieldErrors]="formValidator.formErrors"
                [formControlRef]="
                  convertPaymentControl(customPaymentFields.amount.fieldName)
                "
                class="amount-field"
                (change)="onAmountChange($event.target.value)"
              >
              </app-number>
              <p class="opacity-50 pt-2">{{
                "Buyer.amountP" | translate
              }}</p>
              <p class="opacity-50 pt-2">{{
                "Buyer.mogoMinAmount" | translate
              }}</p>
            </div>
            <div class="col-md-6 px-2 col-sm-12 col-12">
              <div>
                <select
                  #currency
                  (change)="onCurrencyChange(currency.value)"
                  class="inpu-top mt-1 px-3"
                >
                  <option disabled value="null" selected>
                    {{ "Buyer.Choose_the_currency" | translate }}
                  </option>
                  <option selected>EGP</option>
                  <option>USD</option>
                  <option>EUR</option>
                  <option>SAR</option>
                  <option>GBP</option>
                  <option>QAR</option>
                  <option>AED</option>
                </select>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <h2 class="text-primary fw-bold fs-5">{{ "Buyer.SelectPaymentOptions" | translate }}</h2>
      <div class="col-12 mt-3">
        <div class="dropdown col-12 d-flex align-items-center">
          <button
            class="inpu-top form-select d-flex dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {{ buttonText }}
          </button>
          <div
            class="dropdown-menu w-100 border-0"
            aria-labelledby="dropdownMenuButton"
          >
            <div class="payment-card shadow-sm" *ngIf="businessData">
              <div class="payment-card-body">
                <fieldset>
                  <app-buyer-payment-options
                    [expired]="false"
                    [checked]="checked"
                    [isFreePayment]="true"
                    [businessId]="businessId"
                    [totalAmount]="vpihs.total"
                    (clickEvent)="radioChange()"
                    (click)="calculateAmount()"
                  >
                  </app-buyer-payment-options>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <h2 class="mt-3 text-primary fw-bold fs-5">
          {{ "Buyer.Invoice" | translate }}
        </h2>
        <div class="col-12">
          <div class="card mt-2 mb-5">
            <div class="mt-4">
              <div class="d-flex justify-content-between mx-md-5 mx-3">
                <div class="ps-1 fw-semibold">
                  {{ "Buyer.Subtotal" | translate }}
                </div>
                <div class="fw-semibold">
                  {{ subTotal.toFixed(2) }} {{ selectedCurrency }}
                </div>
              </div>
              <div class="fe1 d-flex justify-content-between mx-md-5 mx-3 mt-2">
                <div class="opacity-50">{{ "Buyer.Fees" | translate }}</div>
                <div class="opacity-50">
                  {{ fees.toFixed(2) }} {{ selectedCurrency }}
                </div>
              </div>
              <div class="fe1 d-flex justify-content-between mx-md-5 mx-3 mt-2">
                <div class="fw-bold text-primary">
                  {{ "Buyer.Total" | translate }}
                </div>
                <div class="fw-bold text-primary opacity-75">
                  {{ total.toFixed(2) }} {{ selectedCurrency }}
                </div>
              </div>
              <div
                class="pt-5 pb-3 d-flex justify-content-between align-items-end mx-md-5 mx-3"
              >
                <div>
                  <button
                    class="btn btn-outline-primary rounded-lg btn-sm"
                    type="button"
                    (click)="enableSection()"
                  >
                    {{ "Buyer.EditAmount" | translate }}
                  </button>
                </div>
                <div>
                  <button
                    class="btn btn-primary rounded-lg btn-sm"
                    (click)="submit()"
                    [disabled]="isContinueDisabled()"
                  >
                    {{ "Buyer.Continue" | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
